import { useEffect } from "react";
import { pageViewEvent } from "../services/adobeDataLayer";
import { DataLayerEvent, getValuesInLocalStorange } from "../services/lsq";

function ThankYou() {
  useEffect(() => {
    let pushToDataLayer = async () => {
      const resp = await getValuesInLocalStorange("userData");
      DataLayerEvent(
        resp?.email,
        resp?.mobile,
        "custom_event",
        "lap_campaign",
        "thakyou_page_viwed",
        "NA",
        false
      );
    };
    pushToDataLayer();
    //Trigger ADL on Thank you page load
    pageViewEvent("thank you");
  }, []);
  return (
    <>
      <article className="thankyou_sec">
        <div className="tick">
          <img
            src={process.env.PUBLIC_URL + "/dist/img/call.png"}
            alt="tick"
            width={100}
            height={100}
            className="img-fluid"
          />
        </div>
        <div className="thankyou_txt">
          <p className="mb-5">
            Thank you for your interest
            <br /> in ICICI Bank Loan Against Property.
          </p>
          <span>
            Our representative will get in touch
            <br /> with you from a number starting with 1600-XX-XXXX
          </span>
          <hr />
        </div>
      </article>
    </>
  );
}

export default ThankYou;
